/* eslint-disable @typescript-eslint/restrict-template-expressions */
import Helper from 'utils/Helper';
import IAccessConfiguration from 'common/IAccessConfiguration';
import { LITE_REQUEST_ACCESS } from 'gql/TargetGroup';
import { SingletonResult } from 'gql/Common';
import BaseTarget from './BaseTarget';

export default interface KubernetesClusterObject extends BaseTarget {
  URL: string;
  kasClientTypeName: string;
  clusterInstanceName: string;
  accessConfiguration?: IAccessConfiguration[];
  deleted: boolean;
}
export interface GetClustersFilter {
  name?: string;
  clusterInstanceName?: string;
}

export const KUBERNETES_CLUSTER = `
{
  id
  createdBy
  createdAt
  updatedBy
  updatedAt
  name
  description
  tier
  tags {
    key
    value
  }

  approvalSlackChannel
  notifyAutoApproval
  enablePaging

  teamRole
  managersADGroups
  orgLeaderRole
  limitedAccessRoles
  accessRequiresBastion

  URL
  kasClientTypeName
  clusterInstanceName
  accessConfiguration {
    level
    access ${LITE_REQUEST_ACCESS}
  }
  deleted
  clusterInstanceName
}`;

const GET_CLUSTER = `
  query getKubernetesCluster($id: String, $clusterInstanceName: String) {
    getKubernetesCluster(id: $id, clusterInstanceName: $clusterInstanceName) {
      item ${KUBERNETES_CLUSTER}
    }
  }
`;

export interface GetKubernetesClusterOptions {
  id?: string;
  clusterInstanceName?: string;
}

export const getCluster = async (
  variables: GetKubernetesClusterOptions
): Promise<KubernetesClusterObject | undefined> => {
  const result = await Helper.execGQL<SingletonResult<KubernetesClusterObject | undefined>>({
    query: GET_CLUSTER,
    variables,
  });
  return result.getKubernetesCluster?.item;
};

const GET_CLUSTERS = `
  query listKubernetesClusters {
    listKubernetesClusters ${KUBERNETES_CLUSTER}
  }
`;

export const getClusters = async (filter: GetClustersFilter): Promise<KubernetesClusterObject[]> => {
  const result = await Helper.execGQL<KubernetesClusterObject[]>({
    query: GET_CLUSTERS,
    variables: {
      ...filter,
    },
  });
  let { listKubernetesClusters } = result;
  if (listKubernetesClusters) {
    listKubernetesClusters = result.listKubernetesClusters.filter((k) => {
      return !k.deleted;
    });
  }
  return listKubernetesClusters || [];
};
